<template>
  <nav>
    <v-card
      max-width="960px"
      elevation="0"
      rounded="xxl"
      class="mx-auto fill-height pa-5"
      align="center"
    >
      <v-row
        class="fill-height"
        align="center"
      >
        <v-col v-if="type == 'feedItemDependent'">
          <v-icon
            size="72"
            color="accent"
          >
            mdi-lock-open-check-outline
          </v-icon>
          <v-card-title class="text-h4 font-weight-bold justify-center">
            {{ $t('lockedContentTitle') }}
          </v-card-title>
          <v-card-text class="text-center">
            <p>{{ $t('lockedContentText') }}</p>
            <!-- eslint-disable vue/no-v-html -->
            <p class="text-h5 font-weight-bold">
              {{ content.attributes.title }}
            </p>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              large
              min-width="150"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              color="accent"
              data-testid="redirect-required-item-button"
              @click="redirectToRequiredPage"
            >
              <span>{{ $t('lockedContentLink') }}</span>
            </v-btn>
          </v-card-actions>
        </v-col>
        <v-col v-else>
          <v-icon
            size="72"
            color="accent"
          >
            mdi-lock-open-check-outline
          </v-icon>
          <v-card-title class="text-h4 font-weight-bold justify-center">
            {{ $t('lockedContentTitle2') }}
          </v-card-title>
          <v-card-text class="text-center">
            <p>{{ $t('lockedContentText2') }}</p>
            <!-- eslint-disable vue/no-v-html -->
            <p class="text-h5 font-weight-bold">
              {{ content.date }}
            </p>
          </v-card-text>
         </v-col>
      </v-row>
    </v-card>
  </nav>
</template>
<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: 'feedItemDependent'
    }
  },
  methods: {
      redirectToRequiredPage() {
          var entity = ''
          if (this.content.attributes.entity_type == 'activity_page') {
              entity = 'page'
          } else if (this.content.attributes.entity_type == 'quiz') {
              entity = 'quiz'
          }else if (this.content.attributes.entity_type == 'scorm') {
              entity = 'scorm'
          }else if (this.content.attributes.entity_type == 'checklist') {
              entity = 'checklist'
          }else{
            entity = 'survey'
          }
          if (entity) {
              this.$router.push({path: '/activity/' + this.$route.params.id + '/' + entity + '/' + this.content.attributes.entity_id})
          }
        },
    }
}
</script>